import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (type, extra = {}) => {
  try {
    axios.post(`${API}/track`, { type, ...extra }).catch(() => {});
  } catch (e) {
    /* silent */
  }
};

export const trackPageview = () => track("pageview", { path: window.location.pathname });
export const trackEvent = (name) => track("event", { name });
